import React from 'react';

import {useTemporalStore} from 'apps/experiments/src/store';

import {PageTrackingEvent, trackExperimentPageAction} from '../tracking';
import {useUpdateExperiment} from './update-experiment';
import {useStagedExperiment} from './staged-experiment';

export function useExperimentHistory() {
  const {stagedExperiment: experiment} = useStagedExperiment();
  const {undo: undoHistory, redo: redoHistory} = useTemporalStore((state) => state);
  const updateExperiment = useUpdateExperiment();

  const undo = React.useCallback(() => {
    undoHistory();
    trackExperimentPageAction({
      event: PageTrackingEvent.Undo,
      experiment,
    });
  }, [undoHistory, experiment, updateExperiment]);

  const redo = React.useCallback(() => {
    redoHistory();
    trackExperimentPageAction({
      event: PageTrackingEvent.Redo,
      experiment,
    });
  }, [redoHistory, experiment, updateExperiment]);

  return {
    undo,
    redo,
  };
}
